import type { StatusTone } from '@shared/design-system/ui'
import type { AffiliationStatus } from '@entities/partnership'

const tones: Record<AffiliationStatus, StatusTone> = {
  PENDENTE: 'awaiting',
  APROVADO: 'success',
  RECUSADO: 'closed',
  BLOQUEADO: 'closed',
}

export function affiliationStatusTone(status: AffiliationStatus): StatusTone {
  return tones[status]
}
